import { useTranslation } from 'react-i18next';
import { Badge, type BadgeVariant } from '@/components/Badge';
import type { OpportunityStatus } from '@/pages/Opportunities/types';

export interface OpportunityStatusBadgeProps { status: OpportunityStatus; }
const variants: Record<OpportunityStatus, BadgeVariant> = { decision_pending: 'warning', in_study: 'info', submitted: 'purple', awarded: 'success', discarded: 'neutral' };
export const OpportunityStatusBadge = ({ status }: OpportunityStatusBadgeProps) => {
    const { t } = useTranslation('global');
    return <Badge variant={variants[status]}>{t(`opportunities.status.${status}`)}</Badge>;
};
